module.exports = __webpack_public_path__ + "img/3.6cab2d8f.jpg";